<template>
  <div id="wxa-usage">
    <guide-share-header :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :name="'下单流程'"></guide-share-header>
    <new-user-video-box :video-url="videoUrl"></new-user-video-box>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuideShareHeader from '../component/GuideShareHeader';
import newUserVideoBox from './components/new-user-video-box';

export default {
  name: 'wxa-usage',
  components: {
    GuideShareHeader,
    newUserVideoBox,
  },
  data() {
    return {
      wxaPage: 'pages/me/guide/video-page/video-page',
      wxaPageParam: 'key=1',
      videoUrl: 'https://o.666visa.cn/video/order_place.mp4',
    };
  },
  mounted() {
    sensorsdata.track('UserVideo', {
      video_name: '下单流程',
    });
  },
};
</script>

<style lang="less">
#wxa-usage {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/newUser/WxaUsage.vue